import { render, staticRenderFns } from "./rooms-select.vue?vue&type=template&id=c5f22da8"
import script from "./rooms-select.vue?vue&type=script&lang=js"
export * from "./rooms-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports